import React from 'react';
import { Controller } from 'react-hook-form';
import { Textarea } from "../textarea/Textarea.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function FormTextarea({
  control,
  name,
  rules,
  defaultValue,
  textareaProps
}) {
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    rules: rules,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        onBlur,
        value,
        name,
        ref
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/_jsx(Textarea, {
      ...textareaProps,
      name,
      value,
      inputRef: ref,
      error: error?.message,
      onChange: e => {
        onChange(e);
        textareaProps.onChange?.(e);
      },
      onBlur: e => {
        onBlur();
        textareaProps.onBlur?.(e);
      }
    })
  });
}